// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3zpGg","footer":"ModalFilter_footer__2c6jn"};